"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var __2 = require("../../../..");
var enums_1 = require("../../../../types/enums");
var advocateOptions = [
    'billing_issue',
    'metering_issue',
    'paper_vs_online',
    'prepayment_issue',
    'other',
];
var AdvocateInput = function () {
    var _a, _b, _c, _d;
    var trans = __2.useSemantics().trans;
    var _e = formik_1.useFormikContext(), errors = _e.errors, values = _e.values;
    var advocate = values.project.bget.what_did_you_advocate;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(__1.FormControl, { errors: ((_b = (_a = errors.project) === null || _a === void 0 ? void 0 : _a.bget) === null || _b === void 0 ? void 0 : _b.what_did_you_advocate) || [], label: trans('project:slhh::labels.what-did-you-advocate'), showOther: advocate && advocate.indexOf(enums_1.BooleanOther.OTHER) > -1, other: react_1.default.createElement(__1.FormControl, { errors: (_d = (_c = errors.project) === null || _c === void 0 ? void 0 : _c.bget) === null || _d === void 0 ? void 0 : _d.what_did_you_advocate_other, label: trans('project:slhh::labels.what-did-you-advocate-other') },
                react_1.default.createElement(__1.TextArea, { name: "project.bget.what_did_you_advocate_other", maxLength: 5000 })) },
            react_1.default.createElement("div", { className: "flex flex-col" }, advocateOptions.map(function (key) { return (react_1.default.createElement(__1.Checkbox, { key: "what_did_you_advocate." + key, name: "project.bget.what_did_you_advocate", label: trans("project:slhh::enum.advocate." + key), value: key })); })))));
};
exports.default = AdvocateInput;
//# sourceMappingURL=AdvocateInput.js.map